import axios from "config/axios";
import { GenericListResponse, GenericPageResponse, GenericResponse } from "shared/common";
import { Item, Order, Tool, Warehouse } from "shared/types";

export type Production = {
  id: number;
  tenantId: number;
  item: Item;
  code: string;
  status: ProductionStatus;
  quantity: number;
  toolEntry: Tool;
  relProductionItemEntries: RelProductionItem[];
};

export type ProductionStatus =
  | "CREATED"
  | "READY_TO_PROCESS"
  | "IN_PROGRESS"
  | "MANUFACTURED"
  | "COMPLETED";

export type RelProductionItem = {
  id: number;
  tenantId: number;
  item: Item;
  quantity: number;
  productionId: number;
  warehouse: Warehouse;
};

const ENDPOINT = "/production";

export const listProductionPageable = (
  page: number,
  size: number,
  tenantId: number,
  search: string = "",
  sort: string = "",
) =>
  axios.get<GenericPageResponse<Production>>(
    `${ENDPOINT}/get-page?page=${page}&size=${size}&tenantId=${tenantId}&search=${search}&sort=${sort}`,
  );

export const getProductionById = (param: number, tenantId: number) =>
  axios.post<GenericResponse<Production>>(`${ENDPOINT}/get-by-id`, {
    param,
    tenantId,
  });

export const getProductionByGroupCode = (param: string, tenantId: number) =>
  axios.post<GenericListResponse<Production>>(`${ENDPOINT}/get-by-group-code`, {
    param,
    tenantId,
  });

export const createProduction = (
  productions: {
    production: Partial<Production>;
    orderEntries?: Order[];
    relProductionItemEntries: Partial<RelProductionItem>[];
  }[],
  tenantId: number,
) => axios.post(`${ENDPOINT}`, { productions, tenantId });

export const checkProduction = (
  param: {
    compositeItemId: number;
    quantity: number;
    isCountSubCompositeItems: boolean;
  },
  tenantId: number,
) =>
  axios.post<{
    assemblyItems: {
      item: Item;
      quantity: number;
      warehouseAggregate: {
        item: Item;
        quantity: number;
      };
    }[];
    mainItemAggregate: {
      item: Item;
      quantity: number;
    };
  }>(`${ENDPOINT}/check`, {
    compositeItemId: param.compositeItemId,
    quantity: param.quantity,
    isCountSubCompositeItems: param.isCountSubCompositeItems,
    tenantId,
  });

export const processProduction = ({
  productionEntry,
  assemblyItems,
  toWarehouseId,
  tenantId,
}: {
  productionEntry: Production;
  assemblyItems: RelProductionItem[];
  toWarehouseId: number;
  tenantId: number;
}) =>
  axios.post(`${ENDPOINT}/process`, { productionEntry, assemblyItems, toWarehouseId, tenantId });

export const deleteProductionItems = (id: number, tenantId: number) =>
  axios.delete(`${ENDPOINT}/delete?id=${id}&tenantId=${tenantId}`);

export const processProductionStart = ({
  productionEntry,
  assemblyItems,
  tenantId,
}: {
  productionEntry: Production;
  assemblyItems: RelProductionItem[];
  tenantId: number;
}) =>
  axios.post(`${ENDPOINT}/process/start`, {
    productionEntry,
    assemblyItems,
    tenantId,
    toWarehouseId: 1,
  });
